import firebase from "firebase/app";
import "firebase/auth";

import { Component, Prop, Vue } from "vue-property-decorator";
import { CreateElement } from "vue";

import "@/firebase";
import { db, usersCollection, configurationCollection } from "@/firebase";
import GlobalRules from "./rules";
import Questionnaire from "./Questionnaire";

import VueRecaptcha from "vue-recaptcha";
import RecaptchaContainer from "@/components/Recaptcha.vue";

@Component({
  components: { VueRecaptcha }
})
export default class SignUpTeacher extends Vue {
  private rules = GlobalRules;
  private grades = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    "ESL",
    "Special Education"
  ];
  private gender = ["Female", "Male", "Non-binary"];
  private input_info: any = {};
  private _inputValid: boolean = false;
  private emailExists: boolean = false;
  private _schoolList: string[] = [];
  private recaptcha: boolean = false;

  mounted() {
    this._schoolList = [];
    configurationCollection
      .doc("schools")
      .get()
      .then(async (snapshot: any) => {
        let data = await snapshot.data();
        data["schools"].forEach(
          (schoolData: { name: string; active: boolean }) => {
            if (schoolData.active) {
              this._schoolList.push(schoolData.name);
            }
          }
        );
      })
      .finally(() => {
        this._schoolList.push("Not Affiliated with a school");
        this.$forceUpdate();
      });
  }

  render(h: CreateElement) {
    return <div>{this.studentInfo()}</div>;
  }

  private studentInfo() {
    return (
      <v-row justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="accent" dark flat>
              <v-toolbar-title>
                Teacher registration for BalanceAI
              </v-toolbar-title>
            </v-toolbar>
            <v-form ref="form" v-model={this._inputValid}>
              <v-card-text>
                <v-text-field
                  label="E-mail"
                  name="email"
                  rules={this.rules.email}
                  v-model={this.input_info["email"]}
                  required
                  autocomplete="email"
                  error-messages={
                    this.emailExists ? "Please use a different email." : ""
                  }
                ></v-text-field>
                <v-text-field
                  id="password"
                  label="Password"
                  name="password"
                  rules={this.rules.password}
                  v-model={this.input_info["password"]}
                  type="password"
                  required
                  counter="20"
                  autocomplete="current-password"
                ></v-text-field>
                <v-text-field
                  name="firstname"
                  rules={this.rules.nameRules}
                  type="text"
                  v-model={this.input_info["firstname"]}
                  required
                  autocomplete
                  label="First Name"
                ></v-text-field>
                <v-text-field
                  name="lastname"
                  rules={this.rules.nameRules}
                  type="text"
                  v-model={this.input_info["lastname"]}
                  required
                  autocomplete
                  label="Last Name"
                ></v-text-field>
                <v-select
                  label="Gender"
                  name="gender"
                  v-model={this.input_info["gender"]}
                  items={this.gender}
                  required
                ></v-select>
                <v-autocomplete
                  name="schoolname"
                  hide-no-data
                  v-model={this.input_info["schoolname"]}
                  items={this._schoolList}
                  item-text={this._schoolList}
                  required
                  prepend-icon="mdi-magnify"
                  placeholder="Start typing to search"
                  label="School Name"
                  rules={this.rules.required}
                ></v-autocomplete>
                <v-select
                  label="Grade (check all that apply)"
                  multiple
                  name="grade"
                  v-model={this.input_info["grade"]}
                  items={this.grades}
                  required
                ></v-select>

                <v-container style={{ padding: 20 }}>
                  <v-row justify="center" style={{ marginBottom: "15px" }}>
                    <RecaptchaContainer
                      site_key={process.env.VUE_APP_RECAPTCHA_SITE_KEY}
                      secret={process.env.VUE_APP_RECAPTCHA_SECRET_KEY}
                      verify={this.recaptcha_handler}
                      error={this.recaptcha_handler}
                      expire={this.recaptcha_handler}
                    />
                  </v-row>
                </v-container>
              </v-card-text>
            </v-form>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn
                disabled={!this._formComplete()}
                color="accent"
                onclick={this._checkEmailValidity}
              >
                Create account
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    );
  }

  private recaptcha_handler(res?: any) {
    this.recaptcha = res ? true : false;
    this.$forceUpdate();
  }

  private _formComplete() {
    let form = this.$refs.form as any;
    return form && form.validate() && this.recaptcha;
  }

  private _checkEmailValidity() {
    if (!this._formComplete()) {
      return;
    }

    firebase
      .auth()
      .fetchSignInMethodsForEmail(this.input_info["email"])
      .then((e: string[]) => {
        if (!(e && e[0] === "password")) {
          this.emailExists = false;
          this._createUser();
        } else {
          this.emailExists = true;
          this.$store.dispatch("addNotification", {
            type: "error",
            value: "This email cannot be used. Please use a different email",
            timeout: 3000,
            icon: "mdi-email"
          });
        }
        // this.$forceUpdate();
      })
      .catch((e: any) => {
        this.$store.dispatch("addNotification", {
          type: "error",
          value: "Something went wrong. Please try again.",
          timeout: 5000,
          icon: "mdi-account"
        });
      });
  }

  private _createUser() {
    firebase
      .auth()
      .createUserWithEmailAndPassword(
        this.input_info.email,
        this.input_info.password
      )
      .then(data => {
        this.$store.subscribe((mutation: any, state: any) => {
          if (mutation.type == "SET_LOGGED_IN" && mutation.payload) {
            this._submitPersonalInfo();
            this.$store.dispatch("addNotification", {
              type: "success",
              value: "Creating your account was successful",
              timeout: 4000,
              icon: "mdi-account"
            });
          }
        });
        // create student info and questionnaire
      })
      .catch(err => {
        this.$store.dispatch("addNotification", {
          type: "error",
          value: "Something went wrong. Please try again",
          timeout: 5000,
          icon: "mdi-account"
        });
      });
  }

  private _submitPersonalInfo() {
    if (
      !this.input_info.firstname ||
      !this.input_info.lastname ||
      !this.input_info.gender ||
      !this.input_info.schoolname ||
      !this.input_info.grade
    )
      return;

    let currentUser = firebase.auth().currentUser;

    if (currentUser != null) {
      usersCollection
        .doc(currentUser.uid)
        .set({
          firstname: this.input_info.firstname,
          lastname: this.input_info.lastname,
          gender: this.input_info.gender,
          schoolname: this.input_info.schoolname,
          grade: this.input_info.grade,
          accountType: "teacher",
          dateSubmitted: Date.now()
        })
        .then(() => {
          this.$router.push({ name: "home" }).catch(err => {});
          this.$store.dispatch("addNotification", {
            type: "success",
            value: "Teacher information stored successfully",
            timeout: 4000,
            icon: "mdi-account"
          });
        })
        .catch(err => {
          this.$store.dispatch("addNotification", {
            type: "error",
            value:
              "Failed to store teacher information. Please contact an administrator.",
            timeout: 5000,
            icon: "mdi-account"
          });
        });
    }
  }
}

const component = SignUpTeacher;
